/**
 * Moved to `shared/src/review/site-wide-suppression.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  decidedSiteWideCodes,
  settledSiteWideLabel,
  siteWideCodeFromKey,
  siteWideIssueKey,
  splitSettledSiteWide
} from '@taptimize/shared/dist/review/site-wide-suppression';
export type {
  SiteWideSplit
} from '@taptimize/shared/dist/review/site-wide-suppression';
